/**
 * User: daletan
 * Date: 4/10/14
 * Time: 10:25 AM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */

'use strict';
var blocked;

var $ = require('dibs-jquery-shim');
var _gaq = require('bunsen/helpers/gaq');
var user = require('../../global/models/User');
var SV = require('server-vars');
var tracking = require('dibs-tracking');
var _localStorage = require('dibs-browser-storage').localStorage;
var root = require('bunsen/helpers/windowCheck');
var get = require('lodash.get');

/**
 * @param Array [arr] Array of objects in the style of dibs.tracking.customVars, primarily used for mocking
 */
function createCustomVar(arr) {
    var trackingData = SV.get('tracking') || {};
    var customVars;
    var recentHistoryCount;
    var i;
    var len;
    var trackObj;

    if (!trackingData) {
        trackingData = tracking;
    }
    // sets custom variables if available on page
    customVars = get(trackingData, 'customVars', arr);
    if (customVars && customVars.length) {
        recentHistoryCount = _localStorage.getItem('recent_history_count');
        for (i = 0, len = customVars.length; i < len; i++) {
            trackObj = customVars[i];
            if (trackObj.check_login) {
                trackObj.value = 'log=' + (user.loggedIn() ? 'y' : 'n') + (trackObj.value || '');
            }
            // TRANACT-1802 should only fire 'his=' with custom var 4 and only in search & browse pages
            // the `name` property of custom var 4 would read: "Homepage", or "PDP-Available-Price"
            // TODO: similar implementation in search.tracking.js, near #412, post-release optimization maybe needed
            // don't show on pages that DO NOT display the "recent history" module - TRANACT-2208
            if (trackObj.slot === 4 && !(/^(?:PDP-|Homepage|Shopper)/).test(customVars[i].name)) {
                trackObj.value += '|his=' + (recentHistoryCount ? 'y=' + recentHistoryCount : 'n');
            }
            tracking.setCustomVar(trackObj);
        }
    }

    // set custom variables for session level tracking, in: js/global/core/user.tracking.js
    $.publish('ga:setSessionCustomVar');

}

function referrerTracking() {
    //FINDING-1017
    var referrer = document.referrer;
    var r;
    var rank;
    var kw;
    var p;
    var keyWord;

    if (_gaq && referrer.match(/google\.com/gi) && referrer.match(/cd=/gi)) {
        r = referrer.match(/cd=(.*?)&/);
        rank = parseInt(r[1], 10);
        kw = referrer.match(/q=(.*?)&/);
        p = document.location.pathname;

        if (kw[1].length > 0) {
            keyWord = decodeURI(kw[1]);
        } else {
            keyWord = "(not provided)";
        }

        // can't use dibs.tracking.trackEvent here since it is using _gaq and not _gas
        _gaq.push(['_trackEvent', 'RankTracker', keyWord, p, rank, true]);
    }
}

function pageViewTrackingInit() {
    var settings = SV.get('settings');
    //FINDING-4417 implementing block/unblock of pageview to wait for custom var setting to complete
    $.subscribe('ga:blockPageview', function () {
        blocked = true;
    });

    $.subscribe('ga:unblockPageview', function () {
        blocked = false;
        if (!settings.noInitialPageView) {
            $.publish('ga:pageView');
        }
    });

    // call this privately, expose it to jasmine tests at the bottom of the page
    if (settings.blockCustomVar) {
        $.subscribe('ga:unblockCustomVar', function () {
            createCustomVar();
        });
    } else {
        createCustomVar();
    }

    // broke this out so that the gas.dibs.setup.js file will not fire this data
    // when it is included into a CommonJS module
    (function () {
        var fired;
        var virtualPageName;

        $.subscribe('ga:pageView', function () {
            fired = true;
            // FINDING-2644 - do not allow browser "previews" from firing tracking
            if (settings.allowGa) {
                virtualPageName = root.virtualPageName;

                if (Array.isArray(virtualPageName) && virtualPageName.length) {
                    virtualPageName = '/' + virtualPageName.join('/') + '/';
                } else {
                    /* develblock:start */
                    console.warn('[.com ] root.virtualPageName is a url string on the window that bots are ' +
                        'crawling and indexing. Update it to be an array of uri segments.');
                    /* develblock:end */
                }
                tracking.trackPageview(virtualPageName);
            }
        });

        // this is fired when a modal is closed
        $.subscribe('ga:pageView:once', function () {
            if (!fired) {
                $.publish('ga:pageView');
            }
        });

        // when it is known a modal is going to open on page load (ie. ?modal=register), then
        // dibs.settings.noInitialPageView = true;
        if (!settings.noInitialPageView && !settings.isLegacy && !settings.blockCustomVar && !blocked) {
            $.publish('ga:pageView');
        }
    }());

    // setting this up like this so it can be exposed for testing
    referrerTracking();
}

module.exports = {
    init: pageViewTrackingInit,
    referrer: referrerTracking,
    createCustomVar: createCustomVar
};



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/tracking/gas.dibs.pageview.js
// module id = 2572
// module chunks = 62